import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { merge } from 'rxjs';
import { IHvErweiterungen } from '../../models/hverweiterungen';
import { PopupService } from '../../service/popup.service';

@Component({
  selector: 'app-aufbewahrung-wertsachen',
  templateUrl: './aufbewahrung-wertsachen.component.html',
  styleUrls: ['./aufbewahrung-wertsachen.component.scss']
})
export class AufbewahrungWertsachenComponent implements OnInit  {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  showGroup = true;

  @Output()
  calculateRatePendingEvent = new EventEmitter<void>();

  constructor(public translateService: TranslateService, public popupService: PopupService) { }

  ngOnInit() {
    this.onValueChanged();
  }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      unversperrt: new UntypedFormControl(''),
      en0: new UntypedFormControl(''),
      en1: new UntypedFormControl(''),
      en2: new UntypedFormControl('')
    });
  }

  get unversperrt() { return this.formGroup.get('unversperrt'); }
  get en0() { return this.formGroup.get('en0'); }
  get en1() { return this.formGroup.get('en1'); }
  get en2() { return this.formGroup.get('en2'); }

  onValueChanged(): void {
    merge(
      this.unversperrt.valueChanges,
      this.en0.valueChanges,
      this.en1.valueChanges,
      this.en2.valueChanges
    ).subscribe(() => {
      this.calculateRatePendingEvent.emit();
    });
  }

  getAufbewahrungWertsachen(): IHvErweiterungen {
    return {
      Unversperrt: this.unversperrt.value ? true : false,
      En0: this.en0.value ? true : false,
      En1: this.en1.value ? true : false,
      En2: this.en2.value ? true : false
    } as IHvErweiterungen;
  }

  setAufbewahrungWertsachen(erweiterungen: IHvErweiterungen): void {
    this.unversperrt.setValue(erweiterungen.Unversperrt);
    this.en0.setValue(erweiterungen.En0);
    this.en1.setValue(erweiterungen.En1);
    this.en2.setValue(erweiterungen.En2);
  }
}
